import {enableProdMode} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";

import {AppModule} from "./app/app.module";
import {environment} from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/main.ts